"use client";
import { useLocale } from "next-intl";
import { Link } from "../../../navigation";
import useCMSPageByID from "../../cms/hooks/server/useCMSPageByID";

const BubbleLinkWrapper = ({ link, appearance, children }) => {
  const locale = useLocale();
  const rawLink = typeof link === "string" ? link : (link?.route ?? "");
  const normalizedLink = rawLink.replace("pages://", "");
  const { page } = useCMSPageByID({
    pageId: normalizedLink,
    locale,
  });

  return (
    <Link
      href={page?._r || normalizedLink || "/"}
      className="bubbles__item"
      data-appearance={appearance}
    >
      {children}
    </Link>
  );
};

export default BubbleLinkWrapper;
